module.exports = __webpack_public_path__ + "static/media/swimmy-creation.1df7c95d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/swimmy-creation.png
// module id = 2499
// module chunks = 0